// src/components/cloud/MoveDialog.jsx
import React, { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Box, Typography, Chip
} from '@mui/material';
import FolderTreeView from './FolderTreeView';

const MoveDialog = ({ open, filesToMove, allFiles, onClose, onConfirmMove }) => {
    const [destination, setDestination] = useState(null);

    const handleSelectNode = (path) => {
        setDestination(path);
    };

    const handleConfirm = () => {
        onConfirmMove(destination);
    };

    const handleClose = () => {
        setDestination(null);
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Sposta {filesToMove.length} Elementi</DialogTitle>
            <DialogContent>
                <Typography variant="body2" sx={{ mb: 2 }}>
                    Seleziona la cartella di destinazione:
                </Typography>
                <FolderTreeView allFiles={allFiles} onSelectNode={handleSelectNode} />
                <Box sx={{ mt: 2 }}>
                    <Typography component="span">Destinazione scelta: </Typography>
                    {destination !== null ? (
                        <Chip label={destination === '' ? 'Cartella Principale' : `/${destination}`} color="primary" />
                    ) : (
                        <Typography component="span" fontStyle="italic" color="text.secondary">
                            Nessuna
                        </Typography>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Annulla</Button>
                <Button 
                    onClick={handleConfirm} 
                    variant="contained"
                    disabled={destination === null}
                >
                    Sposta Qui
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MoveDialog;